import { render, staticRenderFns } from "./ExaminationScheduler.vue?vue&type=template&id=ae23dee8&"
import script from "./ExaminationScheduler.vue?vue&type=script&lang=js&"
export * from "./ExaminationScheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports